import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import VPNService from './components/VPNService';
import Features from './components/Features';
import Contact from './components/Contact';
import Legal from './components/Legal';
import Navbar from './components/Navbar';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <VPNService />
      <Features />
      <Contact />
      <Legal />
      <Footer />
    </div>
  );
}
